import * as Yup from 'yup';
import { SERVICE_61_EXPERT_APPOINTMENT } from 'modules/core/constants/services.js';

export const vehicleValidationSchema = Yup.object().shape({
  number: Yup.string().nullable().required('Укажите гос.номер')
    .when(['foreign'], {
      is: true, // alternatively: (foreign) => foreign
      then: (schema) => schema.max(64, 'Максимальная длина 64 символов'),
      otherwise: (schema) => schema
        .max(20, 'Максимальная длина 20 символов')
        .matches(
          /^[АВЕКМНОРСТУХ]{1,2}\s?\d{3,4}\s?[АВЕКМНОРСТУХ]{0,2}\s?\d{2,3}$/i,
          'Некорректный гос.номер'
        ),
    }),

  vin: Yup.string()
    .max(17, 'Максимальная длина 17 символов')
    .matches(/^[a-zA-Z0-9]+$/i, 'Поддерживается только латиница и цифры')
    .matches(
      /^((?:(?![qoi])[0-9a-z]){11,12}|(?:(?![qoi])[0-9a-z]){17})$/i,
      'Некорректный VIN'
    )
    .test(
      'vin service test',
      'Укажите VIN',
      (value, context) => {
        if ((context?.parent?.serviceId === SERVICE_61_EXPERT_APPOINTMENT)
          && context?.parent?.vinRequired
          && ((value === '') || (value === undefined))) return false;
        return true;
      }
    ),
  stsNumber: Yup.string().when('foreign', {
    is: true,
    then: (schema) => schema.max(64, 'Максимальная длина 64 символов'),
    otherwise: (schema) => schema
      .max(10, 'Максимальная длина 10 символов')
      .matches(/^\d{2,4}[а-я\d]{2}\d{6}$/i, 'Некорректный СТС'),
  }),
  ptsNumber: Yup.string().when('foreign', {
    is: true,
    then: (schema) => schema
      .max(64, 'Максимальная длина 64 символов'),
    otherwise: (schema) => schema
      .matches(/^((\d{2}[а-я]{2}\d{6})|(\d{15}))$/i, 'Некорректный ПТС (10 символов: две цифры - две буквы кириллицы - шесть цифр. Второй вариант - номер электронного ПТС - 15 цифр.)'),
  }),
  yearOfIssue: Yup.string()
    .matches(/^[0-9]+$/i, 'Поддерживаются только цифры')
    .max(4, 'Максимальная длина 4 символа'),
  makeId: Yup.number()
    .moreThan(0, 'Укажите марку')
    .nullable()
    .required('Укажите марку'),
  modelId: Yup.number()
    .moreThan(0, 'Укажите модель')
    .nullable()
    .required('Укажите модель'),
});

export const numberValidationSchema = Yup.object().shape({
  number: Yup.string().nullable().required('Укажите гос.номер')
    .when(['foreign'], {
      is: true, // alternatively: (foreign) => foreign
      then: (schema) => schema.max(64, 'Максимальная длина 64 символов'),
      otherwise: (schema) => schema
        .max(20, 'Максимальная длина 20 символов')
        .matches(
          /^[АВЕКМНОРСТУХ]{1,2}\s?\d{3,4}\s?[АВЕКМНОРСТУХ]{0,2}\s?\d{2,3}$/i,
          'Некорректный гос.номер'
        ),
    }),
});
